module.exports = __webpack_public_path__ + "img/bg-top_vrjmof.743b72e3.jpg";